module.exports = __webpack_public_path__ + "img/issue-icon19.61a1c7f.png";